import classes from "./Footer.module.css";

function Footer() {
  return (
    <footer>
      <div className="interface">
        <div className={classes.lineFooter}>
          <div className={`flex ${classes.flex}`}></div>
        </div>
        <div className={`${classes.lineFooter} ${classes.borda}`}>
          <p>© 2026 TERRADATA - Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
